import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IDoctorCounter } from 'src/app/shared/interfaces/doctorCounter';
import { IDoctorException } from 'src/app/shared/interfaces/doctorException';
import { IDoctorTiming } from 'src/app/shared/interfaces/doctorTiming';
import { IDoctorVisit } from 'src/app/shared/interfaces/doctorVisit';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-doctor-calendar',
  templateUrl: './doctor-calendar.component.html',
  styleUrl: './doctor-calendar.component.css'
})
export class DoctorCalendarComponent implements OnInit {

  drCalendarList: IDoctorTiming[];
  drID: any;
  exceptionDays: IDoctorException[];
  drTimeCounter: IDoctorCounter = {
    bodyCounter: null,
    videoCounter: null,
    soundCounter: null
  };
  hourList = [
    { title: '00', value: 0 },
    { title: '01', value: 60 },
    { title: '02', value: 120 },
    { title: '03', value: 180 },
    { title: '04', value: 240 },
    { title: '05', value: 300 },
    { title: '06', value: 360 },
    { title: '07', value: 420 },
    { title: '08', value: 480 },
    { title: '09', value: 540 },
    { title: '10', value: 600 },
    { title: '11', value: 660 },
    { title: '12', value: 720 },
    { title: '13', value: 780 },
    { title: '14', value: 840 },
    { title: '15', value: 900 },
    { title: '16', value: 960 },
    { title: '17', value: 1020 },
    { title: '18', value: 1080 },
    { title: '19', value: 1140 },
    { title: '20', value: 1200 },
    { title: '21', value: 1260 },
    { title: '22', value: 1320 },
    { title: '23', value: 1380 },
    { title: '24', value: 1440 }
  ];

  constructor(
    public apiService: ApiService,
    private http: HttpClient,
    private route: ActivatedRoute) { }


  ngOnInit(): void {
    this.drID = this.route.snapshot.params.id;

    this.getDrCalendarList();
    this.getDrException();
    this.getDrCounter();
  }

  getDrException() {
    this.apiService.apiCall('get', '/api/Doctor/GetAllException/' + this.drID).subscribe((res: any) => {
      // console.log(res);
      this.exceptionDays = res.body.model;
    })
  }

  getDrCounter() {
    this.apiService.apiCall('get', '/api/Doctor/GetAllCounter/' + this.drID).subscribe((res: any) => {
      // console.log(res);
      this.drTimeCounter = res.body.model;
    })
  }

  getDrCalendarList() {
    // get default docotr time table
    this.http.get('../../../../../assets/json/drCalendarTable.json').subscribe((res: IDoctorTiming[]) => {

      this.drCalendarList = res;
    })

    this.apiService.apiCall('get', '/api/Doctor/GetAllDoctorActive/' + this.drID).subscribe((res: any) => {
      console.log(res);

      if (res.body.model != null || res.body.model.length != 0) {

        const updatedList = this.drCalendarList.map(item1 => {
          const matchingItem = res.body.model.find(item2 => item2.day === item1.day);

          if (matchingItem) {
            return {
              ...item1,
              ...matchingItem,
              visitTypes: item1.visitTypes.map(v1 => {
                const matchingVisitType = matchingItem.visitTypes.find(v2 => v2.type === v1.type);
                return matchingVisitType ? matchingVisitType : v1;
              })
            };
          }

          return item1;
        });

        this.drCalendarList = updatedList;

        // console.log(updatedList);
      }

    })
  }

}
